import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, ModalController } from 'ionic-angular';
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { DatabaseProvider, clinic } from "../../providers/database/database";
import { AuthProvider } from '../../providers/auth/auth';
import { AdminUsersAddPage } from '../admin-users-add/admin-users-add';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-admin-users',
  templateUrl: 'admin-users.html',
})
export class AdminUsersPage implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  public userList: Observable<any[]>;
  public programList: Observable<any[]>;
  program_selected: any = {};
  rows: any[] = [];

  constructor(public modalCtrl: ModalController, public alertCtrl: AlertController, public navCtrl: NavController, public navParams: NavParams, private database: DatabaseProvider, private loadingCtrl: LoadingController, private auth: AuthProvider) {
    this.auth.getUserToken().then((token) => {
      console.log('User Token: ', token);
    });
   
    this.programList = this.database
    .getPrograms()
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      })
    })
  }

  ionViewDidLoad() {
    this.database.getUsers()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((users) => {
        this.rows = users;
      });
  }

  ngOnInit()  {

  }

  ngOnDestroy() {
    console.log('Leave admin users and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  showClinic(ev, clinic)  {
    console.log('clinic event: ', ev);
    console.log('clinic: ', clinic);
    this.program_selected = clinic;
  }

  onActivate(event) {
    if(event.type === 'dblclick') {
      console.log('Activate Event', event.row);
    }
  }

  deleteUser(user)  {
    let confirm = this.alertCtrl.create({
      title: "Delete User",
      message:
        "Are you sure you would like to delete this user?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            console.log('Delete User: ', user.id);
            const loader = this.loadingCtrl.create({
              content: "Deleting User..."
            });
        
            loader.present()
            this.database.deleteUser(user.id).then((result) => {
              loader.dismiss();
              console.log('delete user: ', result);
            })
            .catch((error) => {
              loader.dismiss();
              console.log('delete user error: ', error);
            })
          }
        }
      ]
    });
    confirm.present();
  }

  presentAddUserModal() {
    let profileModal = this.modalCtrl.create(AdminUsersAddPage, { 'program': this.programList }, {showBackdrop: true, enableBackdropDismiss: false});
    profileModal.present();
  }
}




// WEBPACK FOOTER //
// ./src/pages/admin-users/admin-users.ts